<template>
  <div>
    <my-notification :icon="'cog'">
      <template #title>
        {{ $t(section) }}
      </template>
    </my-notification>
    <br />
    <b-notification
      v-for="setting in coreStore.conf.tunableSettings(section)"
      :key="setting.id"
      :closable="false"
    >
      <b-field :label="setting.name">
        <component
          v-if="isComponentInput(setting)"
          :is="setting.component"
          v-model="csettings[setting.id]"
          @input="updateSetting($event, setting.id)"
        />
      </b-field>
    </b-notification>
    <br />
    <nav class="level">
      <div class="level-left"></div>
      <div class="buttons level-right">
        <b-button icon-left="save" type="is-primary" @click="valider()">
          <span>{{ $t('save') }}</span>
        </b-button>
      </div>
    </nav>
  </div>
</template>

<script>
import Vue from 'vue'
import { useCoreStore } from '@/stores/core.js'

export default {
  // Commute MAX_DISTANCES
  // Commute TRAVELS_MODES
  // Travels PURPOSE
  // Travels STATUS
  // Travels MODE
  // Travels MODES_DEPLACEMENTS
  // Travels PURPOSE_DICTIONARY
  // Travels STATUS_DICTIONARY
  // Travels MODE_DICTIONARY
  // Travels ROUND_TRIP_DICTIONARY
  // api Tutelle > Administrations
  // api DomaineScientifique / DomaineDisciplinaire / SousDomaine
  // facteurs d'émissions
  name: 'SettingsEditor',
  props: {
    section: {
      type: String,
      required: true
    }
  },
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  },
  data () {
    return {
      csettings: {}
    }
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  methods: {
    isComponentInput: function (setting) {
      return setting.isTunable()
    },
    updateSetting: function (value, id) {
      this.csettings[id] = value
      this.coreStore.updateSettings({
        id: id,
        value: value
      })
    },
    valider: function () {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })
      this.coreStore
        .saveSettings()
        .then((settings) => {
          window.scrollTo(0, 0)
          let self = this
          this.$buefy.toast.open({
            type: 'is-light',
            message: self.$t('compSuperadminSettingsEditor.save-msg')
          })
          loadingComponent.close()
        })
        .catch((erreur) => {
          // TODO
          loadingComponent.close()
        })
    }
  },
  mounted () {
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })
    this.coreStore
      .getSettings()
      .then((conf) => {
        this.csettings = {}
        for (let setting of conf.settings) {
          this.csettings[setting.id] = setting.value
        }
        // load all input components
        for (let setting of conf.settings) {
          if (this.isComponentInput(setting)) {
            Vue.component(setting.component, () =>
              import('@/components/superadmin/settings/' + setting.component)
            )
          }
        }
        loadingComponent.close()
      })
      .catch((erreur) => {
        loadingComponent.close()
      })
  }
}
</script>
